import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { TeamMessageService } from '../service/team-message.service';
import {
  Router,
  RouterLink,
  RouterOutlet
} from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { ThemePalette } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-team-message-data',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatListModule,
    MatProgressSpinnerModule,
    TranslateModule,
  ],
  templateUrl: './team-message-data.component.html',
  styleUrl: './team-message-data.component.css'
})
export class TeamMessageDataComponent {
  color : ThemePalette = 'accent';
  driverId = 0;
  isLoading = false;
  teamMessageArray!: any[];
  constructor(        
    private router: Router,    
    private teamMessageService: TeamMessageService,
    translate: TranslateService, 
  ) {     
    let browserLangToUse = '';
    let browserLang = translate.getBrowserCultureLang();
    browserLangToUse = browserLang === undefined ? 'en' : browserLang;
    console.log(browserLang);    
    translate.setDefaultLang('en');    
    translate.use(browserLangToUse);    
  }
  ngOnInit(): void {
    let overrideObjectString = localStorage.getItem("overrideObject");
    if(overrideObjectString === null){
      console.log(`team-message-data not override apex id`);
      this.pageInitialization();
    } 
    else{
      console.log(`team-message-data override apex id`);
      this.pageInitializationOverride(overrideObjectString);
    }
  }
  private pageInitialization(): void {
    this.isLoading = true;
    let apexid = localStorage.getItem("apexid"); 
    if(apexid !== null){
      this.getTeamMessageByApexId(apexid);
    }    
  }
  private pageInitializationOverride(overrideObjectString:string): void{
    let overrideObject = JSON.parse(overrideObjectString);
    console.log(overrideObject);
    let apexid = overrideObject.apexid;
    this.isLoading = true;
    if(overrideObject.dashboardTeamMessageDetails.length === 0){
      this.teamMessageArray = [];
    }
    else if(overrideObject.dashboardTeamMessageDetails[0] === null){
      this.teamMessageArray = [];
    }
    else{
      this.teamMessageArray = overrideObject.dashboardTeamMessageDetails.slice(0, 3);
      for (const teamMessage of this.teamMessageArray){
        teamMessage.isOpen = false;
        teamMessage.fullBody = '';
        teamMessage.isLoading = false;
        teamMessage.dateTime = this.formatDateTime(teamMessage.created_On);
      }      
    }
    let driverId = overrideObject.driverId;
    if(driverId !== null){
      this.driverId = Number(driverId);
    }
    this.isLoading = false; 
  }  
  getTeamMessageByApexId(apexid:string):void{
    let dashboardTeamMessageDetails = localStorage.getItem("dashboardTeamMessageDetails");
    if(dashboardTeamMessageDetails === null){
      let driverCountry = localStorage.getItem("driverCountry");
      let driverBusinessType = localStorage.getItem("driverBusinessType");      
      if(driverCountry === null && driverBusinessType === null){
        // driver does not exist
        this.teamMessageArray = [];
        this.isLoading = false; 
      }
      else{
        this.teamMessageService.getTeamMessageByApexId(apexid).subscribe(responseTeamMessageObject => {
          if(responseTeamMessageObject.length === 0){
            this.teamMessageArray = [];
          }
          else if(responseTeamMessageObject[0].dashboardTeamMessageDetails[0] === null){
            this.teamMessageArray = [];
          }
          else{
            this.teamMessageArray = responseTeamMessageObject[0].dashboardTeamMessageDetails.slice(0, 3);        
            for (const teamMessage of this.teamMessageArray){
              teamMessage.isOpen = false;
              teamMessage.fullBody = '';
              teamMessage.isLoading = false;
              teamMessage.dateTime = this.formatDateTime(teamMessage.created_On);
            }
            this.driverId = responseTeamMessageObject[0].driver.driver_Id;  
            this.isLoading = false;    
          }                  
        });
      }      
    }
    else{      
      let dashboardTeamMessageDetailsArray = JSON.parse(dashboardTeamMessageDetails);
      if(dashboardTeamMessageDetailsArray.length === 0){
        this.teamMessageArray = [];
      }
      else if(dashboardTeamMessageDetailsArray[0] === null){
        this.teamMessageArray = [];        
      }
      else{
        this.teamMessageArray = JSON.parse(dashboardTeamMessageDetails).slice(0, 3);   
        for (const teamMessage of this.teamMessageArray){
          teamMessage.isOpen = false;
          teamMessage.fullBody = '';
          teamMessage.isLoading = false;
          teamMessage.dateTime = this.formatDateTime(teamMessage.created_On);
        } 
      }
      let driverId = localStorage.getItem("driverId")
      if(driverId !== null){
        this.driverId = Number(driverId);
      }      
      this.isLoading = false;           
    }    
  }  
  goToDetail(teamMessage: any): void {
    this.router.navigate(['/team-message-detail', { message_id: teamMessage.teamMessage_Id, 
      driver_id: this.driverId, sender: teamMessage.author, 
      time: teamMessage.created_On, readTime: teamMessage.readTime,
      getAttachmentS3Url: teamMessage.getAttachmentS3Url }]);
  }
  private formatDateTime(created_On: string): string {
    // throw new Error('Function not implemented.');
    // 2024-03-28T05:16:46.644514Z
    let formatedDateTime = '';
    let date = new Date(created_On);
    // 3/28/2024
    let datePart = date.toLocaleDateString();
    let timePart = date.toLocaleTimeString().replace(/(.*)\D\d+/, '$1');
    formatedDateTime = datePart + ' ' + timePart;
    return formatedDateTime;
  }
}
